<!--Insight widget-->
<div class="insight-content" [style]="containerStyle" #htmlContent>
  <div class="insight-body">
    <aside class="insight-panel">
      <!-- The title heads the key figures, aligned as chosen within the column; a line under it. -->
      @if (showTitle && !isLoading()) {
      <header class="insight-title">
        @if (richTitle) {
        <app-widget-title class="flush" [title]="title" [design]="widget?.design?.title"></app-widget-title>
        } @else {
        <p class="insight-title-text" [style.font-size.px]="widget?.design?.title?.fontSize || 16"
          [style.text-align]="widget?.design?.title?.align || 'center'">{{ title }}</p>
        }
      </header>
      }

      @if (insight.figure?.enabled) {
      <section class="insight-block">
        <span class="insight-label">{{ insight.figure?.label || ('editor.insight_source_' + (insight.figure?.source ||
          'meanDays') | translate) }}</span>
        @switch (insight.figure?.source || 'meanDays') {
        @case ('meanDays') {
        <div class="insight-headline">
          <strong class="insight-figure">{{ values.meanDays === null ? '—' : delayText(values.meanDays) }}</strong>
          <ng-container [ngTemplateOutlet]="riskTrend"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="delayDetails"></ng-container>
        }

        @case ('medianDays') {
        <div class="insight-headline">
          <strong class="insight-figure">{{ values.medianDays === null ? '—' : delayText(values.medianDays) }}</strong>
          <ng-container [ngTemplateOutlet]="riskTrend"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="delayDetails"></ng-container>
        }

        @case ('trend') {
        <strong class="insight-figure">{{ values.trendPct === null ? '—' : (values.trendPct > 0 ? '+' : '') +
          (values.trendPct | number: '1.0-0') + ' %' }}</strong>
        }

        @case ('total') {
        <strong class="insight-figure">{{ values.total ?? '—' }}</strong>
        }

        @default {
        <strong class="insight-figure">{{ values.last ?? '—' }}</strong>
        }
        }
      </section>
      }

      <!-- Beside a delay, the trend of the risk (a lower rate is good news); under it, its range and its probable date -->
      <ng-template #riskTrend>
        @if (values.riskTrend) {
        <span class="insight-trend" [ngClass]="'trend-' + values.riskTrend">{{ 'editor.insight_risk_' + values.riskTrend |
          translate }}</span>
        }
      </ng-template>

      <ng-template #delayDetails>
        @if (values.delayRange) {
              <small>{{ 'editor.insight_delay_range' | translate: { min: delayText(values.delayRange[0]), max:
                delayText(values.delayRange[1]) } }}</small>
        }
        @if (values.dueDate) {
        <small>{{ 'editor.insight_due_date' | translate: { date: (values.dueDate | date: 'dd/MM/yyyy') } }}</small>
        }
      </ng-template>

      @if (insight.probabilities?.enabled) {
      <section class="insight-block">
        <span class="insight-label">{{ 'editor.insight_probabilities' | translate }}</span>

        @for (probability of values.probabilities; track probability.days) {
        <div class="insight-bar" [matTooltip]="probabilityHint(probability)">
          <span>{{ 'editor.insight_within_days' | translate: { days: probability.days } }}</span>
          <span class="insight-track"><span class="insight-fill" [style.width.%]="probability.percent"></span></span>
          <span class="insight-value">{{ probability.percent | number: '1.0-0' }} %</span>
        </div>
        } @empty {
        <span class="insight-missing">—</span>
        }
      </section>
      }

      @if (tenantId && insight.ranking?.enabled) {
      <section class="insight-block">
        <span class="insight-label">{{ 'editor.insight_ranking' | translate }}</span>

        @for (rank of ranking; track rank.name) {
        <div class="insight-rank">
          <span class="insight-rank-name" [title]="rank.name">{{ rank.name }}</span>
          <span class="pill" [ngClass]="'tone-' + rank.tone">{{ rank.value }}</span>
        </div>
        } @empty {
        <span class="insight-missing">—</span>
        }
      </section>
      }

      @if (insight.note?.enabled && note) {
      <p class="insight-note">{{ note }}</p>
      }
    </aside>

    <div class="insight-chart">
      @if (error && !isLoading()) {
      <span class="error">{{ error }}</span>
      }

      <div class="chart" [class.hidden]="isLoading()">
        <canvas #chartCanvas style="width: 100%; height: 100%"></canvas>
      </div>

      @if (isLoading()) {
      <app-widget-loading [graphType]="widget?.graphType"></app-widget-loading>
      }

      <app-forecast-note [meta]="forecastMeta"></app-forecast-note>
    </div>
  </div>

  @if (widgetRendered && !isLoading()) {
  <div id="chart-rendered"></div>
  }
</div>